// @ts-check
import React, { useContext } from "react";
import "../App.css";
import "./component.css";
import { Primary } from "./Primary";
import { Secondary } from "./Secondary";
import Library from "./Library";
import { State } from "../context/State";
import { Tertiary } from "./Tertiary";

export function Planetary() {
  const { showLibrary } = useContext(State);
  return (
    <div className="holder">
      <div className="secondary">
        <Secondary />
      </div>
      <div className="primary">
        <Primary />
      </div>
      <div className="library">{showLibrary && <Library />}</div>
      <Tertiary />
    </div>
  );
}
